import VerofreshRecord from './VerofreshRecord'

/**
 * This is a faux model used in the interface for the 'Vehicles With High Reefer' Activity index page so that we can
 * use the js-data orm via RemoteDataTableMixin, even though we're not using a typical CRUD resource on the remote end.
 * This lets us interface with the endpoint via PagedCollection in a straightforward way, as well.
 */
class HighReeferActivityVehicleRecord extends VerofreshRecord {
  static get endpoint () { return 'sustainability-insights/vehicles' }
}
export default HighReeferActivityVehicleRecord
